// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__27MTA","title":"Header_title__1mHSd","left":"Header_left__jqM84","clinicName":"Header_clinicName__2Yw16"};